
import {
  Mixins,
  Component,
  Watch,
  Prop,
} from 'vue-property-decorator';
import {
  Card,
  Col,
  Button,
  Row,
  Dialog,
  Select,
  Option,
  Form,
  FormItem,
  Input,
  Radio,
  RadioGroup,
  Table,
  TableColumn,
} from 'element-ui';
import api from '@/api/sensitive';

@Component({
  components: {
    Card,
    Col,
    Button,
    Row,
    Dialog,
    Select,
    Option,
    Form,
    FormItem,
    Input,
    Radio,
    RadioGroup,
    Table,
    TableColumn,
  },
})

export default class addMoadal extends Mixins() {
  @Prop({
    default: false,
    required: true,
  }) show!: boolean;

  public $refs!: {
    form: Form,
  };

  private visible: boolean = this.show;

  private form: any = {
    addWord: '',
  }

  private rules: any = {
    addWord: [
      { required: true, message: '请输入敏感词', trigger: 'change' },
    ],
  }

  OnClose() {
    this.$emit('update:show', false);
  }

  submit() {
    this.$refs.form.validate((valid: boolean) => {
      if (valid) {
        const data = { word: this.form.addWord };
        api.addSensitive(data).then((res) => {
          this.$emit('update:show', false);
          this.$emit('addFinish');
        });
      } else {
        return false;
      }
      return true;
    });
  }

  resetForm() {
    this.$refs.form.resetFields();
  }

  reset() {
    this.resetForm();
  }
}
